import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { Column, ColumnKeys } from './grid-config';
import { sortByColumn } from '../utils/sorters';
import { EncryptionExclusionItem } from '@nirvana/shared/dtos/types/policies/common';

export class GzEncryptionExclusionsGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  EncryptionExclusionItem
> {
  sortByColumnMethod(
    a: EncryptionExclusionItem,
    b: EncryptionExclusionItem,
    sortColumnName: string,
    sortDirection: string
  ): number {
    return sortByColumn(a, b, sortColumnName, sortDirection);
  }
}
